enum DecommissionStatus {
  PROVISIONING = "PROVISIONING",
  ACTIVATED = "ACTIVATED",
  PRE_DECOMMISSIONING = "PRE_DECOMISSIONING",
  DECOMMISSIONED = "DECOMISSIONED",
  PENDING_CREDENTIALS = "PENDING_CREDENTIALS",
  RENEWAL_CREDENTIALS = "RENEWAL_CREDENTIALS",
  AWAITING_PROVISIONING_INPUT = "AWAITING_PROVISIONING_INPUT",
  AWAITING_RENEWAL_INPUT = "AWAITING_RENEWAL_INPUT",
  READY_TO_SEND = "READY_TO_SEND",
}

export default DecommissionStatus;
